module.exports = __webpack_public_path__ + "img/new-question-set.55cb32dd.png";